import { Subject } from 'rxjs';
import { BaseProvider } from 'src/app/core/services/base-provider';
import * as i0 from "@angular/core";
import * as i1 from "../../core/services/globals.service";
import * as i2 from "@angular/common/http";
import * as i3 from "../../core/services/utils.service";
export class CreditService extends BaseProvider {
    constructor(globals, http, utils) {
        super();
        this.globals = globals;
        this.http = http;
        this.utils = utils;
        this.purchaseList = [];
        this.balance = [];
        this.toggleDateFormatError = false;
        this.getBalanceEvent = new Subject();
        this.getCreditPurchasesEvent = new Subject();
        this.page = 1;
        this.size = 10;
        this.baseUrl = 'creditExternal';
    }
    getBalance() {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl +
                this.baseUrl;
            this.http.get(this.url).subscribe((data) => {
                this.balance = data.Data;
                resolve(data.Data);
            }, (err) => {
                reject(err);
            });
        });
    }
    payCreditAndSubmit(data, transactionId) {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl + this.baseUrl + `/credit/payment/${transactionId}`;
            this.http
                .post(this.url, data)
                .subscribe((data) => {
                resolve(data);
            }, err => { reject(err); });
        });
    }
    getPurchases(params) {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl +
                this.baseUrl +
                '/page/' + params.pageNumber +
                '/size/' + params.pageSize;
            this.http.get(this.url).subscribe((data) => {
                this.purchaseList = data.Data;
                resolve(data.Data);
            }, (err) => {
                reject(err);
            });
        });
    }
    pay(data) {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl + this.baseUrl;
            this.http
                .post(this.url, data)
                .subscribe((data) => {
                resolve(data);
            }, err => { reject(err); });
        });
    }
}
CreditService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function CreditService_Factory() { return new CreditService(i0.ɵɵinject(i1.GlobalsService), i0.ɵɵinject(i2.HttpClient), i0.ɵɵinject(i3.UtilsService)); }, token: CreditService, providedIn: "root" });
